import { render } from "./AuthorPage.vue?vue&type=template&id=2b315cbe&scoped=true"
import script from "./AuthorPage.vue?vue&type=script&lang=js"
export * from "./AuthorPage.vue?vue&type=script&lang=js"

import "./AuthorPage.vue?vue&type=style&index=0&id=2b315cbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b315cbe"

export default script